<template>
  <div>
    <p
      v-if="chatStatusInfo !== null"
      class="mb-2"
      :class="chatBlockedClass"
    >
      {{chatStatusStr}}
    </p>

    <div
      class="top-panel"
    >
      <b-button v-b-modal.help-modal>Help</b-button>

      <b-button
        v-if="mayEditPlayerData && chatStatusInfo !== null && isChatBlocked"
        :to="{name: 'player_chat_unblock_add', params: {playerId: playerId}}"
        variant="primary"
      >
        Unblock chat
      </b-button>
    </div>

    <p v-if="message !== null">
      {{message}}
    </p>

    <template
      v-if="log !== null && log.length > 0"
    >
      <player-chat-block-log-item
        v-for="item in log"
        :key="createItemKey(item)"
        :playerId="playerId"
        :object="item"
        :userMap="userMap"
        class="mb-3"
      />
    </template>

    <loading-indicator
      v-if="isLoading"
    />

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          На данной странице показан <strong>журнал отключений чата</strong>.
          В&nbsp;журнале отключений чата хранится информация
          о&nbsp;отключении и&nbsp;досрочном включении чата для определенного игрока.
          Для каждого отключения и&nbsp;включения сохраняется пользователь,
          который выполнил данное действие, и&nbsp;причина.
        </p>
        <p>
          Администраторы и&nbsp;модераторы имеют право досрочно включить чат игроку.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import PlayerChatBlockLogItem from './PlayerChatBlockLogItem.vue';

import { convertUserArrayToMap } from '../model/user';
import { getChatStatusStr } from '../model/player-chat-block-log';
import { isChatBlocked as utilIsChatBlocked } from '../model/player-chat-block-log';
import { mayEditPlayerData as utilMayEditPlayerData } from '../util';

export default {
  name: 'PlayerChatBlockLog',

  components: {
    LoadingIndicator,
    PlayerChatBlockLogItem,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      actor: auth.getViewer(),
      isLoading: false,
      chatStatusInfo: null,
      log: null,
      userMap: null,

      nowSec: Date.now() / 1000,
    };
  },

  computed: {
    message() {
      if(this.log !== null && this.log.length === 0) {
        return 'Chat block log is empty.';
      }
      return null;
    },

    mayEditPlayerData() {
      return utilMayEditPlayerData(this.actor.role);
    },

    chatStatusStr() {
      return getChatStatusStr(this.chatStatusInfo, this.nowSec);
    },

    isChatBlocked() {
      return utilIsChatBlocked(this.chatStatusInfo, this.nowSec);
    },

    chatBlockedClass() {
      return {
        chatBlocked: this.isChatBlocked,
      };
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.isLoading = true;

    const url = `/player/${this.playerId}/chat_block_log`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.userMap = convertUserArrayToMap(data.users);

      this.chatStatusInfo = data.chatStatusInfo;

      const log = data.log;
      log.sort((a, b) => b.ctime - a.ctime);

      this.log = log;
    })
    .catch(e => {
      this.isLoading = false;
      notifier.showError(e.response.data, {sender: this});
    });
  },

  methods: {
    createItemKey(item) {
      return item.type.toString() + '_' + item.id.toString();
    },
  },
};
</script>

<style scoped>
.top-panel {
  margin-bottom: 1rem;
}

.chatBlocked {
  color: var(--red);
}
</style>